<a [routerLink]="[]" queryParamsHandling="preserve" mat-stroked-button color="primary" [disabled]="disabled"
  [ngClass]="{ disabled: disabled }" (click)="click($event)">
  <mat-icon *ngIf="fontSet" [fontSet]="fontSet" [fontIcon]="icon"></mat-icon>
  <mat-icon *ngIf="!fontSet" [svgIcon]="icon" class="svg-icon"></mat-icon>
  <span>&nbsp;{{ text }}</span>
</a>

<!-- <button mat-stroked-button color="primary">
  <mat-icon *ngIf="fontSet" [fontSet]="fontSet" [fontIcon]="icon"></mat-icon>
  <mat-icon *ngIf="!fontSet" [svgIcon]="icon" class="svg-icon"></mat-icon>
  <span>&nbsp;{{ text }}</span>
</button> -->